<template>
  <div class="reportFootNote">
    <div class="footNote">
      <p class="title">{{ reportData && reportData.reportStatement }}</p>
      <p class="desc">质检时间：{{ reportData && reportData.checkDate }}</p>
    </div>
    <img
      v-if="reportData && reportData.sealPic"
      class="stamp"
      :src="$setPicSize(reportData && reportData.sealPic)"
    />
  </div>
</template>
<script>
  import { setPicSize } from '@zz-common/zz-utils'
  export default {
    components: {},
    props: {
      reportData: {
        type: Object,
        default: () => ({}),
      },
    },
    computed: {
      $setPicSize() {
        return setPicSize
      },
    },
  }
</script>
<style lang="scss" scoped>
  @import '@zz-common/zz-ui/lib/style/mixins/ellipsis.scss';
  .reportFootNote {
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    width: 686px;
    height: 128px;
    padding: 0 44px;
    .footNote {
      .title {
        @include ellipsis();
        width: 506px;
        color: #111111;
        font-weight: 300;
        font-size: 22px;
        font-family: PingFangSC-Light;
        line-height: 1;
      }

      .desc {
        margin: 14px 0 0;
        color: #999999;
        font-weight: 300;
        font-size: 20px;
        font-family: PingFangSC-Light, PingFang SC;
      }
    }
    .stamp {
      width: 104px;
      height: 104px;
      object-fit: cover;
    }
  }
</style>
